/** Planes exclusivos página Mundial — precios tachados promocionales, checkout = precio real */

export const WC_TARGET = new Date('2026-06-11T20:00:00-05:00');

export const wcPlans = [
  {
    id: 'bronce',
    planId: '29',
    name: 'MUNDIAL BRONCE',
    badge: 'OFERTA MUNDIAL',
    originalPrice: '49.00',
    price: '29.00',
    savePercent: 41,
    duration: '12 MESES',
    link: 'https://tvsola.com/checkout.php?id=29',
    highlight: 'Todos los partidos del Mundial 2026',
    features: [
      'Canales deportivos Mundial en FULL HD / 4K',
      '+79.000 Canales, +249.000 Películas y Series',
      'Netflix, Disney+, HBO Max, Prime y más',
      'Ligue 1 Plus + España en 4K',
      'Catch-up y EPG · Sin cortes en directo',
      'IBO Pro Player GRATIS incluido',
      '15 Días de Garantía de Reembolso',
    ],
  },
  {
    id: 'plata',
    planId: '39',
    name: 'MUNDIAL PLATA',
    badge: 'EL MÁS ELEGIDO',
    originalPrice: '69.00',
    price: '39.00',
    savePercent: 43,
    duration: '24 MESES',
    link: 'https://tvsola.com/checkout.php?id=39',
    isPopular: true,
    highlight: '2 temporadas · Mejor precio por mes',
    features: [
      'Prioridad servidores durante el Mundial',
      'Canales + VOD Adultos incluidos',
      '+79.000 Canales, +249.000 Películas y Series',
      'Todos los partidos + repeticiones VOD',
      'Calidad 4K / FULL HD / HD / SD',
      'IBO Pro Player GRATIS incluido',
      '15 Días de Garantía de Reembolso',
    ],
  },
  {
    id: 'oro',
    planId: '49',
    name: 'MUNDIAL ORO',
    badge: 'MÁXIMO AHORRO',
    originalPrice: '89.00',
    price: '59.00',
    savePercent: 34,
    duration: '24 MESES',
    link: 'https://tvsola.com/checkout.php?id=59',
    screens: 2,
    highlight: '2 pantallas · Familia y amigos',
    features: [
      'Dos pantallas activas simultáneas',
      'Mundial + Champions + LaLiga en 4K',
      'Canales + VOD Adultos incluidos',
      '+79.000 Canales, +249.000 Películas y Series',
      'Soporte VIP WhatsApp 24/7',
      'IBO Pro Player GRATIS incluido',
      '15 Días de Garantía de Reembolso',
    ],
  },
];

export const wcLifetime = {
  planId: '119',
  name: 'MUNDIAL VIP LIFETIME',
  badge: 'SOLO 50 CUPOS',
  originalPrice: '249.00',
  price: '119.00',
  savePercent: 48,
  duration: 'DE POR VIDA',
  link: 'https://tvsola.com/checkout.php?id=119',
  screens: 2,
  features: [
    'Acceso permanente — un solo pago',
    'Mundial 2026 + todos los eventos futuros',
    '2 pantallas · Actualizaciones de por vida',
    'IBO Pro Player GRATIS de por vida',
    'Soporte prioritario',
    '30 Días de Garantía de Reembolso',
  ],
};

export const wcPerks = [
  { title: '104 partidos', desc: 'Todo el Mundial en directo' },
  { title: '4K / FHD', desc: 'Calidad premium sin cortes' },
  { title: 'Activación', desc: 'En menos de 5 minutos' },
  { title: 'Garantía', desc: '15 días reembolso' },
];
